import {SmartComponent} from "smart-component-js";

class PrizesFilterComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.filter = this.element.querySelector('.prizesFilter__select select');
        this.init();


    }

    filteredList() {
        // this.filters.forEach((filter) => {

        this.filter.addEventListener('change', () => {
            let filterValue = $('.prizesFilter__select.points-select select').val();


            let filterQuery = "";

            if (filterValue !== '') {
                let startPoints = $('.prizesFilter__select.points-select select').val().split('_')[0];
                let endPoints = $('.prizesFilter__select.points-select select').val().split('_')[1];
                filterQuery += `requiredPoints=ge=${startPoints};requiredPoints=le=${endPoints};`;
            }


            document.querySelector('.yxp-reward-list-widget-container').dispatchEvent(new CustomEvent('yxp-reward-list-filter-change', {
                detail: filterQuery

            }));
        })
        // })
    }


    sortList() {
        $('#sortSelect').on('change', function () {
            let sortVal = $(this).val();
            document.querySelector('.yxp-reward-list-widget-container')
                .dispatchEvent(new CustomEvent('yxp-reward-list-order-change', {
                    detail: sortVal
                }));
        });
    }

    checkPreloadFilter() {
        document.querySelector('.yxp-reward-list-widget-container').addEventListener('yxp-reward-list-initialized', () => {
            let preLoadFilter = $('.yxp-reward-list-widget').attr('data-default-order-by');

            if (preLoadFilter != '') {
                $(`input[value="${preLoadFilter}"]`).prop('checked', true);
            }
        });

    }

    init() {
        this.checkPreloadFilter();
        this.filteredList();
        this.sortList();
    }
}

export default PrizesFilterComponent;
